export const selectDaysOptions = [
  {
    id: 1,
    label: "Global",
    value: "global",
    disabled: false,
  },
  {
    id: 2,
    label: "Últimos 7 dias",
    value: "weekly",
    disabled: false,
  },
  {
    id: 3,
    label: "Últimos 30 dias",
    value: "monthly",
    disabled: false,
  },
];

export const getRankingSelectDayLabelFromValue = (value: string): string =>
  selectDaysOptions?.find((option) => option?.value === value)?.label;
